import { routeTemplates } from "@cirrus-delivery/v1/router/routeTemplates"

export const routeTemplatesWhitelist = [
  routeTemplates.info.config,
  routeTemplates.nda.config,
  routeTemplates.eula.config,
  routeTemplates.finish.config,
  routeTemplates.registration.config,
  routeTemplates.page.config,
  routeTemplates.results.config,
  routeTemplates.exam.config,
  routeTemplates.annotations.config,
]

export const routeTemplateIdsWhitelist = [
  routeTemplates.info.id,
  routeTemplates.nda.id,
  routeTemplates.eula.id,
  routeTemplates.finish.id,
  routeTemplates.registration.id,
  routeTemplates.page.id,
  routeTemplates.results.id,
  routeTemplates.exam.id,
  routeTemplates.annotations.id,
]

export const BrowserCompatibilityErrorType = {
  compatible: "Compatible",
  regularNotAllowed: "RegularNotAllowed",
  safeOldVersion: "SafeOldVersion",
}

export const ApplicationStage = {
  beforeExam: "beforeExam",
  afterExam: "afterExam",
}
